const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  userName: state => state.user.userName,
  orgName: state => state.user.orgName,
  orgNo: state => state.user.orgNo,
  httpStatus: state => state.user.httpStatus,
  loginShow: state => state.user.loginShow,
  coreToken: state => state.user.coreToken,
}
export default getters
